var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuizIconOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0458 17.7259C39.4098 19.6243 37.808 21.2061 35.875 21.2061H24.5C22.5669 21.2061 21 19.6392 21 17.7061V6.33117C21 4.39818 22.5818 2.79637 24.4802 3.16031C31.8374 4.57076 37.6355 10.3687 39.0458 17.7259ZM36.4679 18.2201C35.2597 11.9187 30.2874 6.94642 23.986 5.73838C23.9391 5.72937 23.9213 5.73502 23.916 5.73672C23.9057 5.73995 23.8733 5.7525 23.829 5.79436C23.7317 5.88599 23.625 6.07448 23.625 6.33117V17.7061C23.625 18.1895 24.0168 18.5811 24.5 18.5811H35.875C36.1317 18.5811 36.3202 18.4744 36.4119 18.3772C36.4537 18.3328 36.466 18.3013 36.4693 18.2908C36.471 18.2854 36.4768 18.2672 36.4679 18.2201Z",
    fill: "#6F6F67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8469 5.10421C17.6405 4.90013 18.375 5.52883 18.375 6.3482C18.375 6.98851 17.9172 7.53169 17.2995 7.70053C11.3632 9.32329 7 14.7552 7 21.2062C7 28.9382 13.268 35.2062 21 35.2062C27.451 35.2062 32.883 30.8431 34.5058 24.9068C34.6745 24.2892 35.2177 23.8312 35.858 23.8312C36.6774 23.8312 37.3062 24.5659 37.1021 25.3593C35.2576 32.5315 28.7478 37.8312 21 37.8312C11.8183 37.8312 4.375 30.3879 4.375 21.2062C4.375 13.4585 9.67484 6.94866 16.8469 5.10421Z",
    fill: "#6F6F67"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizIconOverview);
export default __webpack_public_path__ + "static/media/quiz-icon-overview.be912020c7a85ed9ff9bf2482272ef4c.svg";
export { ForwardRef as ReactComponent };